import React from 'react'
import PropTypes from 'prop-types'

import moment from 'moment'

import styles from './styles'

function PepAnswer(props) {
  const { questionData } = props
  const answers = questionData?.answer?.answer_object
  const classes = styles()

  return (
    <div className={classes.root}>
      <h2>Pessoa Exposta Politicamente</h2>
      <div className={classes.formWrapper}>
        <h3>Pergunta:</h3>
        <p>{questionData.text}</p>
        {answers && (
          <React.Fragment>
            <h3>Resposta:</h3>
            <div className={classes.subject}>
              <p>
                <span>Cargo: </span> {answers.role}
              </p>
              <p>
                <span>Atividades desempenhadas na função: </span>{' '}
                {answers.developed_activities}
              </p>
              <p>
                <span>A quem se reporta/reportava na estrutura do orgão: </span>
                {answers.reports_to}
              </p>
              <p>
                <span>A qual órgão é/era vinculado: </span>{' '}
                {answers.organization}
              </p>
              <p>
                <span>Ainda se encontra na função: </span>{' '}
                {answers.currently_at_this_job ? 'sim' : 'não'}
              </p>
              {answers.currently_at_this_job ? (
                <p>
                  <span>Jornada de trabalho:</span>{' '}
                  {`de ${answers.start_working_hours} às ${answers.end_working_hours} horas.`}
                </p>
              ) : (
                <p>
                  <span>Data exata em que o vínculo foi interrompido:</span>{' '}
                  {moment(answers.end_of_contract).format('DD/MM/YYYY')}
                </p>
              )}
            </div>
          </React.Fragment>
        )}
      </div>
    </div>
  )
}

PepAnswer.propTypes = {
  questionData: PropTypes.shape({
    uuid: PropTypes.string.isRequired,
    text: PropTypes.string,
    occurrence: PropTypes.object,
    answered: PropTypes.bool.isRequired,
    subject: PropTypes.string.isRequired,
    answer: PropTypes.object,
  }).isRequired,
}

export default PepAnswer
